export const ADULT_MINIMUM_AGE = 18;
export const INDEPENDENT_MINOR_MINIMUM_AGE = 13;
